module.exports = __webpack_public_path__ + "static/media/spell.fdd200c1.mp3";